const seoContentStatus = process.env.GATSBY_SEO_CONTENT_STATUS

exports.checkShowSEOContentStatus = () => {
  if (seoContentStatus === 'disabled') {
    return false
  }

  return true
}
